import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";

// Self-hosted fonts (needed so COEP: require-corp doesn't block Google Fonts)
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/jetbrains-mono/400.css";

import "./index.css";
import Record from "./pages/Record";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import AdminVideo from "./pages/AdminVideo";
import BestOf from "./pages/BestOf";
import Home from "./pages/Home";

const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/r/:linkId", element: <Record /> },
  { path: "/best-of", element: <BestOf /> },
  { path: "/admin", element: <Admin /> },
  { path: "/admin/login", element: <AdminLogin /> },
  // Legacy redirect for old AdminList path
  { path: "/admin/videos", element: <Navigate to="/admin#videos" replace /> },
  { path: "/admin/videos/:videoId", element: <AdminVideo /> },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
